import { graphqlClient } from "../../../client";
import mutationDocument from "./sendWishlistMutation.graphql";
import type { Mutations, MutationsSendWishlistArgs, SendWishlistType } from "@/core/api/graphql/types";

export async function sendWishlist(payload: SendWishlistType): Promise<boolean> {
  const { data } = await graphqlClient.mutate<Required<Pick<Mutations, "sendWishlist">>, MutationsSendWishlistArgs>({
    mutation: mutationDocument,
    variables: {
      command: {
        ...payload,
      },
    },
  });

  return data!.sendWishlist;
}
